import { downloadSizes } from '../consts';
import { paddTo } from './padd-to';

export const convertGalleryDownloadSize = (number: number) => {
  const maxSize = Math.pow(2, downloadSizes.length) - 1;
  const enabledDownloadSizes: { [key: string]: boolean } = {};

  if (number > maxSize) {
    downloadSizes.filter(s => s.name !== 'reserved').forEach(size => (enabledDownloadSizes[size.name] = true));
  } else {
    const downloadSizesString = paddTo((number >>> 0).toString(2), 8);
    downloadSizes.forEach((size, i) => {
      enabledDownloadSizes[size.name] = downloadSizesString[i] === '1';
    });
  }
  return enabledDownloadSizes;
};
